import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getDaysUntilReset(resetDate) {
  const now = new Date();
  const reset = new Date(resetDate);
  const diff = reset - now;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
